/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import RopeBlue from "../../../../../Asset/icon/rope_blue.svg";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getYachtDetail } from "../../../../../redux/yacht/YachtSlice";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { useTranslation } from "react-i18next";
import "./customCheckbox.css";

const TravelAgent = ({ travelAgents, setTravelAgentFilter, preYachtAgent }) => {
  const { t } = useTranslation();

  const [selectedAgents, setSelectedAgents] = useState(
    Array.from(preYachtAgent)
  );
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      dispatch(getYachtDetail({})),
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const YachtInfoName = loading
    ? []
    : todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.map(
      (yacht) => ({
        ...yacht,
        name_yacht: todos.YachtSlice.Yacht.results.find(
          (yachtInfo) => yachtInfo.id_yacht === yacht.id_yacht
        )?.name_yacht,
      })
    );

  useEffect(() => {
    setTravelAgentFilter(selectedAgents);
  }, [selectedAgents, setTravelAgentFilter]);

  const handleCheckboxChange = (event) => {
    const selectedAgent = event.target.value;
    setSelectedAgents((prevSelected) =>
      prevSelected.includes(selectedAgent)
        ? prevSelected.filter((agent) => agent !== selectedAgent)
        : [...prevSelected, selectedAgent]
    );
  };

  const handleClearFilter = () => {
    setSelectedAgents([]);
  };

  return (
    <div className="d-flex flex-column align-items-center position-relative">
      <div className="mb-4">
        <div
          className="absolute-left-text"
        >
          {t("Travel Agent")}
        </div>
        <div
          className="absolute-right-link"
        >
          <a onClick={handleClearFilter}>{t("CLEAR")}</a>
        </div>
      </div>
      <div className="mt-4 w-80-percent">
        <Form className="d-flex flex-column align-items-start">
          {travelAgents.map((agent) => (
            <Form.Check
              className="custom-checkbox"
              key={agent}
              type="checkbox"
              id={agent}
              label={
                <div className="text-left">
                  {agent} (
                  {
                    YachtInfoName.filter((yacht) => yacht.name_yacht === agent)
                      .length
                  }
                  )
                </div>
              }
              value={agent}
              onChange={handleCheckboxChange}
              checked={selectedAgents.includes(agent)}
            />
          ))}
        </Form>
      </div>
      <div>
        <img className="m-4" draggable={false} src={RopeBlue} alt="RopeBlue" />
      </div>
    </div>
  );
};

export default TravelAgent;
